import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconPricingRocket: React.FC<IconProps> = ({ width = 21, height = 20 }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_11498_39464)">
            <path
                d="M15.4305 8.8195C17.3055 6.9445 17.4227 4.71403 17.3641 3.7195C17.3543 3.56792 17.2897 3.42508 17.1823 3.31767C17.0749 3.21027 16.932 3.14565 16.7805 3.1359C15.7859 3.07731 13.557 3.19293 11.6805 5.0695L6.75 9.99996L10.5 13.75L15.4305 8.8195Z"
                stroke="#23262A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M11.1259 5.625H6.30953C6.14399 5.62508 5.98524 5.69082 5.86812 5.80781L3.18453 8.49141C3.10259 8.57352 3.04513 8.67682 3.01856 8.78974C2.992 8.90265 2.99738 9.02074 3.03411 9.13077C3.07084 9.2408 3.13747 9.33844 3.22654 9.41275C3.31561 9.48707 3.4236 9.53513 3.53843 9.55156L6.75093 10"
                stroke="#23262A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M14.875 9.375V14.1914C14.8749 14.3569 14.8092 14.5157 14.6922 14.6328L12.0086 17.3164C11.9265 17.3983 11.8232 17.4558 11.7103 17.4824C11.5973 17.5089 11.4793 17.5036 11.3692 17.4668C11.2592 17.4301 11.1616 17.3635 11.0872 17.2744C11.0129 17.1853 10.9649 17.0773 10.9484 16.9625L10.5 13.75"
                stroke="#23262A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M7.8875 14.6742C7.58516 15.3375 6.56641 16.8758 3.625 16.8758C3.625 13.9344 5.16328 12.9156 5.82656 12.6133"
                stroke="#23262A"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_11498_39464">
                <rect width="20" height="20" fill="white" transform="translate(0.5)" />
            </clipPath>
        </defs>
    </svg>
);

export default IconPricingRocket;
